"use strict";

exports.__esModule = true;
exports.DeviceGridWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _DeviceGridElement = require("./DeviceGridElement");
var _DeviceGridFields = require("./DeviceGridFields");
var _DeviceGridHeader = require("./DeviceGridHeader");
var _DeviceGridThumbnail = require("./DeviceGridThumbnail");
var _EditableDeviceGridElement = require("./EditableDeviceGridElement");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DeviceGridWidget = exports.DeviceGridWidget = {
  name: "DeviceGrid",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "DeviceGridWidget.label",
    defaultMessage: "Device Grid"
  }),
  icon: "layout-grid",
  group: _widgetGroups.LAYOUT_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "DeviceGrid",
      props: Object.assign({
        width: 800,
        height: 600,
        itemHeight: 300,
        itemWidth: 300,
        dataRange: ""
      }, props),
      children: [{
        type: "Grid",
        props: {
          rowCount: 12,
          columnCount: 12
        },
        children: []
      }]
    };
  },
  showInPalette: true,
  isParent: true,
  requiresContexts: [],
  suppliesContexts: ["device"],
  optionalProps: ["rowGutter", "columnGutter", "onClickAction", "backgroundColor", "backgroundColorSource"],
  requiresProps: ["x", "y", "width", "height", "itemWidth", "itemHeight"],
  suppliesProps: ["x", "y", "width", "height"],
  propConstraints: {
    width: {
      "default": 800,
      min: 256,
      max: 3840
    },
    height: {
      "default": 600,
      min: 256,
      max: 2160
    },
    itemWidth: {
      "default": 300,
      min: 128,
      max: function max(props) {
        return props.width;
      }
    },
    itemHeight: {
      "default": 300,
      min: 64,
      max: function max(props) {
        return props.height;
      }
    }
  },
  components: {
    Header: _DeviceGridHeader.DeviceGridHeader,
    Element: _DeviceGridElement.DeviceGridElement,
    Fields: _DeviceGridFields.DeviceGridFields,
    Editable: _EditableDeviceGridElement.EditableDeviceGridElement,
    Thumbnail: _DeviceGridThumbnail.DeviceGridThumbnail
  }
};